// Wspólny `fetch` helperów API (lib/api, training, motoryka, motoryka/admin, squad,
// pobieranie xlsx) — jedyne miejsce, które widzi 401/403 każdego zapytania.
//
// Nic tu nie przerywa ani nie zmienia odpowiedzi: helper dostaje ją jak z gołego
// `fetch` i obsługuje błąd po swojemu. Dodatkowo leci globalne zdarzenie, na które
// reaguje AppShell — ale TYLKO przy włączonej fladze AUTH_REQUIRED (przy wyłączonej
// nikt go nie słucha, więc zachowanie aplikacji jest jak dawniej):
//   401 → okno logowania NAD stroną (strona zostaje zamontowana, niezapisane
//         tagowanie / LIVE nie przepada), po zalogowaniu „powtórz ostatnią akcję";
//   403 → dyskretny komunikat z `detail` z API (np. sam Podgląd na trasie zapisu).
// /api/auth/* pomijamy — tam 401 to normalna odpowiedź („niezalogowany"), nie wygaśnięcie.

export const UNAUTHORIZED_EVENT = 'legia:unauthorized'
export const FORBIDDEN_EVENT = 'legia:forbidden'

export interface UnauthorizedEventDetail { path: string }
export interface ForbiddenEventDetail { path: string; detail: string }

const FORBIDDEN_FALLBACK = 'Brak uprawnień do tej operacji.'

function pathOf(input: RequestInfo | URL): string {
  if (typeof input === 'string') return input
  if (input instanceof URL) return input.pathname
  return input.url
}

function emit(path: string, res: Response): void {
  if (typeof window === 'undefined') return
  if (/^(https?:\/\/[^/]+)?\/api\/auth\//.test(path)) return
  if (res.status === 401) {
    window.dispatchEvent(new CustomEvent<UnauthorizedEventDetail>(UNAUTHORIZED_EVENT, { detail: { path } }))
    return
  }
  // Klon — ciało oryginału czyta helper (komunikat błędu), a my tylko podglądamy `detail`.
  res.clone().json()
    .then((body) => (typeof body?.detail === 'string' && body.detail ? body.detail : FORBIDDEN_FALLBACK))
    .catch(() => FORBIDDEN_FALLBACK)
    .then((detail) => {
      window.dispatchEvent(new CustomEvent<ForbiddenEventDetail>(FORBIDDEN_EVENT, { detail: { path, detail } }))
    })
}

export async function apiFetch(input: RequestInfo | URL, init?: RequestInit): Promise<Response> {
  const res = await fetch(input, init)
  if (res.status === 401 || res.status === 403) emit(pathOf(input), res)
  return res
}
